"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const RadioButtonCheckedIcon = (props) => (react_1.default.createElement(core_1.SvgIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z" })));
const RadioButtonUncheckedIcon = (props) => (react_1.default.createElement(core_1.SvgIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })));
const RadioCheckedIcon = (0, core_1.withStyles)((theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
    },
    inner: {
        position: 'absolute',
        left: 0,
    },
}))((props) => {
    const { classes, fontSize, color } = props;
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(RadioButtonUncheckedIcon, { fontSize: fontSize, color: color }),
        react_1.default.createElement(RadioButtonCheckedIcon, { fontSize: fontSize, color: color, className: classes.inner })));
});
exports.default = RadioCheckedIcon;
//# sourceMappingURL=RadioCheckedIcon.js.map